export default "__VITE_ASSET__60540452__"